export function parseNumber(string) {
  return string ? string.toString().trim().replace(/[^0-9]/g, '') : '';
}
